<script>
  import {EdiCommentAuthorBadger, EdiCommentPartnerBadger} from '../index';
  import {AUTHOR_COMMENT, PARTNER_COMMENT, DEFAULT_COMMENT} from "../../api";

  export default {
    functional: true,
    props: {
      age: Number,
      courtesy: String,
      type: {
        type: String,
        validator: (v) => [AUTHOR_COMMENT, PARTNER_COMMENT, DEFAULT_COMMENT].includes(v),
      },
    },
    render(createElement, context) {
      switch (context.props.type) {
        case AUTHOR_COMMENT:
          return createElement(EdiCommentAuthorBadger, context);
        case PARTNER_COMMENT:
          return createElement(EdiCommentPartnerBadger, context);
        case DEFAULT_COMMENT:
          // Si el comentario es "normal" (no socio o autor) no lleva badger
          return null;
        default:
          // No debería entrar nunca aquí ya que en las props se validan los dos
          // únicos valores posibles.
          return null;
      }
    }
  }
</script>
